import { i18n } from "i18next";
import { useI18nContext } from "./hooks/useI18nContext";

// To wrap class components
export const I18nContextWrapper = ({ children }: { children: any }) => {
  const ctx: i18n = useI18nContext();
  if (ctx === undefined) throw new Error(`must be used within a I18nProvider`);
  return children(ctx);
};
